module.exports = __webpack_public_path__ + "assets/img/count-type.2ddb1f1e.svg";